import React, {FC} from 'react';
// clsx
import clsx from 'clsx';
// material Ui
import {Box} from '@mui/material';
// import {makeStyles, createStyles, Theme} from '@mui/material';

const drawerWidth = 240;
// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {},
//     footerBar: {
//       boxShadow: 'none',
//       background: 'transparent',
//       // borderTop: '1px solid #ADCDF0',
//       transition: theme.transitions.create(['width', 'margin'], {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.leavingScreen,
//       }),
//       position: 'fixed',
//       bottom: 0,
//       width: '100%',
//       padding: '0px 10px',
//       zIndex: 9
//     },
//     footerBarShift: {
//       marginLeft: drawerWidth,
//       width: `calc(100% - ${drawerWidth}px)`,
//       transition: theme.transitions.create(['width', 'margin'], {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.enteringScreen,
//       }),
//       position: 'fixed',
//       bottom: 0,
//       paddingLeft: '32px',
//     },
//   })
// );

export interface IDashboardFooterProps {
  open: boolean;
}

const DashboardFooter: FC<IDashboardFooterProps> = (props) => {
  // props speading
  const {open} = props;
  // const classes = useStyles();
  return (
    <div
      // className={clsx(classes.footerBar, {
      //   [classes.footerBarShift]: open,
      // })}
      style={{
        position: 'fixed',
        bottom: '0',
        width: '100%',
        padding: '15px'
      }}
    >
      <Box display="flex">
        <Box>
          <p className="sub-content-text" style={{color: '#0bb0ef'}}>
            2022 All Rights Reserved By Alphastream.ai. Terms and Conditions. Privacy Policy
          </p>
        </Box>
        <Box ml="auto">
          <p className="sub-content-text" style={{color: '#0bb0ef', textAlign: 'center'}}>
            Powered by <a style={{color:'#0bb0ef'}} href='https://alphastream.ai/'  target="_blank" rel="noreferrer noopener">Alphastream.ai</a>
          </p>
        </Box>
      </Box>
    </div>
  );
};

export default DashboardFooter;
